import { render } from "./TradingRules.vue?vue&type=template&id=669263f0&scoped=true"
import script from "./TradingRules.vue?vue&type=script&lang=js"
export * from "./TradingRules.vue?vue&type=script&lang=js"

import "./TradingRules.vue?vue&type=style&index=0&id=669263f0&lang=scss&scoped=true"
import "./TradingRules.vue?vue&type=style&index=1&id=669263f0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669263f0"]])

export default __exports__